"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildRuleResultRefined = void 0;
const buildRuleResultRefined = (applicationRule) => ({
    ID: applicationRule.ID,
    access: applicationRule.access,
    application: applicationRule.application,
    criteria: applicationRule.criteria,
    overriden: applicationRule.overriden,
    tag: applicationRule.rule.tag,
});
exports.buildRuleResultRefined = buildRuleResultRefined;
//# sourceMappingURL=RuleResultRefined.js.map